import React from "react";
import styles from "./purchaseOrderItem.module.css";
import moment from "moment";
import { IMAGE_PATH } from "../../../Utils/variables";

export const PurchaseOrdersItem = ({
  po_id,
  community_id,
  title,
  name,
  sub_total,
  total_amount,
  delivery_date,
  handleDetail,
  onClickTabItem,
  activeTabId,
}) => {
  return (
    <>
      <div
        className={
          activeTabId === po_id
            ? styles.mainDivPOItemsActive + " " + styles.activetab
            : styles.mainDivPOItems
        }
        onClick={() => {
          handleDetail(po_id, community_id);
          onClickTabItem(po_id);
        }}
      >
        <h1>{title}</h1>
        <div className={styles.ImgPOItems}>
          {activeTabId === po_id ? (
            <div>
              <img src={IMAGE_PATH + "carbonBuilding.png"} alt="" />
            </div>
          ) : (
            <div>
              <img src="./images/stratum/carbonBuildingInactive.png" alt="" />
            </div>
          )}
          <h1>{name}</h1>
        </div>
        <span
          className={
            activeTabId === po_id
              ? styles.amountDateDivPOItemsActive
              : styles.amountDateDivPOItems
          }
        >
          <h5>PO Amount</h5>
          {delivery_date && <h5>Delivery Date</h5>}
        </span>
        <span
          className={
            activeTabId === po_id
              ? styles.amountDateDivPOItemsActive
              : styles.amountDateDivPOItems
          }
        >
          <p>{`${total_amount} AED`}</p>
          {delivery_date && (
            <p>
              {delivery_date == ""
                ? "-"
                : moment(delivery_date).format("DD MMM YYYY")}
            </p>
          )}
        </span>
      </div>
    </>
  );
};
